module.exports = __webpack_public_path__ + "img/domiciliu1.9a4d01f0.jpeg";